export default __webpack_public_path__ + "static/media/_DSC0292.d69e167f.JPG";